import React, { createContext, useContext, useState, ReactNode } from 'react';
import WaitlistModal from '@/components/WaitlistModal';

interface WaitlistContextType {
    isOpen: boolean;
    openWaitlist: () => void;
    closeWaitlist: () => void;
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined);

export const WaitlistProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const openWaitlist = () => setIsOpen(true);
    const closeWaitlist = () => setIsOpen(false);

    return (
        <WaitlistContext.Provider value={{ isOpen, openWaitlist, closeWaitlist }}>
            {children}
            <WaitlistModal isOpen={isOpen} onClose={closeWaitlist} />
        </WaitlistContext.Provider>
    );
};

export const useWaitlist = (): WaitlistContextType => {
    const context = useContext(WaitlistContext);
    if (!context) {
        throw new Error('useWaitlist must be used within a WaitlistProvider');
    }
    return context;
};
